import React from 'react';
import { Contact } from '../../components';
import { homeObjOne } from './Data';
function contactus() {
  return (
    <>
      <Contact {...homeObjOne} />
    </>
  );
}

export default contactus;
